var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { ImagesManager } from '@front/controls/misc/ImagesManager';
import { ThemeManager } from '@front/controls/misc/ThemeManager';
export class SymbolSvgLogoManager {
    static LoadSvgImage(logoAddress) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!logoAddress) {
                return null;
            }
            return yield ImagesManager.GetSvg(logoAddress);
        });
    }
    static getDefaultImage(symbol) {
        let firstLetter = '';
        if (symbol) {
            firstLetter = symbol.substring(0, 1).toUpperCase();
        }
        return ('<svg width=\"32\" height=\"32\" viewBox=\"0 0 32 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">' +
            '<path d=\"M0 5.33333C0 2.38782 2.38781 0 5.33333 0H26.6667C29.6122 0 32 2.38781 32 5.33333V26.6667C32 29.6122 29.6122 32 26.6667 32H5.33333C2.38782 32 0 29.6122 0 26.6667V5.33333Z\" fill=\"' +
            this.backgroundColorName +
            '\"/>' +
            '<text fill=\"' +
            this.foregroundColorName +
            '\" xml:space=\"preserve\" style=\"white-space: pre\" font-family=\"Roboto\" font-size=\"24\" letter-spacing=\"0em\" x=\"50%\" y=\"25px\" text-anchor=\"middle\"><tspan>' +
            firstLetter +
            '</tspan></text></svg>');
    }
    static getDefaultImageInBase64(symbol) {
        let defaultImageSvg = this.getDefaultImage(symbol);
        const backgroundColor = ThemeManager.colors.defaultInstrumentLogoBackground;
        const foregroundColor = ThemeManager.colors.defaultInstrumentLogoForeground;
        defaultImageSvg = defaultImageSvg.replace(this.backgroundColorName, backgroundColor);
        defaultImageSvg = defaultImageSvg.replace(this.foregroundColorName, foregroundColor);
        const base64Svg = `data:image/svg+xml;base64,${btoa(defaultImageSvg)}`;
        return base64Svg;
    }
}
SymbolSvgLogoManager.backgroundColorName = 'var(--default-instrument-logo-background)';
SymbolSvgLogoManager.foregroundColorName = 'var(--default-instrument-logo-foreground)';
